import { isDayAfter } from '../../../utilities/isDayAfter'
import { isDayBefore } from '../../../utilities/isDayBefore'

export const ANCHOR_LEFT = 'left'
export const ANCHOR_RIGHT = 'right'
export const DEFAULT_DATE_FORMAT = 'MM-dd-yyyy'
export const HORIZONTAL_ORIENTATION = 'horizontal'
export const VERTICAL_ORIENTATION = 'vertical'
export const WRAPPER_CLASS_NAME = 'active-date-picker'

export const isOutsideRangeUtil = function (day, minDate, maxDate) {
  return (
    (!!minDate && isDayBefore(day, minDate)) ||
    (!!minDate && isDayAfter(day, maxDate))
  )
}
